import {
	createContext,
	Dispatch,
	ReactNode,
	SetStateAction,
	useContext,
	useState,
} from "react";
import CartOverlay from "./CartOverlay.client";

type CartOverlayContextType = {
	setShowCart: Dispatch<SetStateAction<boolean>>;
	showCart: boolean;
};
const CartOverlayContext = createContext({} as CartOverlayContextType);

export const useCartOverlay = () => useContext(CartOverlayContext);

type Props = {
	children: ReactNode;
};
const CartOverlayProvider = ({ children, ...props }: Props) => {
	const [showCart, setShowCart] = useState(false);

	return (
		<CartOverlayContext.Provider
			value={{
				setShowCart,
				showCart,
			}}
		>
			{children}
		</CartOverlayContext.Provider>
	);
};
export default CartOverlayProvider;
